import React, { useState } from 'react';
import { useWidgetContext, WidgetContext } from '../data/widgets/WidgetContext';
import { StreamingContext } from '../live/Live';
import LiveMatchDataFetcher from '../live/match/LiveMatchDataFetcher';
import { PrematchContext } from './Prematch';

function PrematchLiveMatch(props) {
    const prematchContext = React.useContext(PrematchContext);
    const [widgetContext] = useWidgetContext('#br_widget');
    const [streamingContext, setStreamingContext] = useState({
        streamingId: null,
        streamingMatchId: null,
        streamingProps: null,
        toggleStreamingId: function(streamingProps,id,matchId) {
            setStreamingContext(function(prev) {
                return  {
                    ...prev,
                    streamingId: prev.streamingId==id?null:id,
                    streamingMatchId: matchId,
                    streamingProps: streamingProps
                }
            });
        }
    });

    return (
        <WidgetContext.Provider value={widgetContext}>
            <StreamingContext.Provider value={streamingContext}>
                <LiveMatchDataFetcher match={props.match} tournaments={[{...prematchContext.tournament}]} />
            </StreamingContext.Provider>
        </WidgetContext.Provider>
    );
}

export default PrematchLiveMatch;